import { Component, OnInit, Input, Optional } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-group-error-message',
    templateUrl: './form-group-error-message.component.html',
    styleUrls: ['./form-group-error-message.component.css']
})
export class FormGroupErrorMessageComponent implements OnInit {

    @Input()
    errorMessage!: string;

    @Input()
    formGroup: FormGroup | undefined;

    constructor(@Optional() private controlContainer: ControlContainer, private translateService: TranslateService) {
    }

    ngOnInit() {
        this.formGroup = this.controlContainer.control as FormGroup;
    }

    public validateFormGroup = (): boolean => {
        return this.formGroup!.invalid && this.formGroup!.touched;
    }

    public getErrors(): string[] {
        const errors: string[] = [];
        if (this.formGroup && this.formGroup.errors) {
            for (const key in this.formGroup.errors) {
                if (this.errorMessage == key) {
                    if (this.formGroup.errors.hasOwnProperty(key)) {                        
                        const msg = this.translateService.instant(`validation.${key}`);
                        errors.push(msg);
                    }
                }
            }
        }
        return errors;
    }
}
